import { BundleCatalogRoundInfoListModel } from '../kymw1300/vo/bundle-catalog-round-info-list.model';
import { MediumTypeModel } from '../kymw1300/vo/medium-type.model';
import { KYMW1320Component } from './kymw1320.component';

/**
 * プロモ商品企画点検リスト画面の値を管理するクラス
 *
 * @export KYMW1320Model
 * @class KYMW1320Model
 */
export class KYMW1320Model {

  public kymw1320Component: KYMW1320Component;

  /** 全媒体保持用リスト */
  public mediumTypeList: MediumTypeModel[] = [];
  /** フィルター後の媒体リスト表示用 */ 
  public dispMediumTypeList: MediumTypeModel[] = [];
  /** 束ね企画リスト */
  public dispBundleCatalogRoundInfoList: BundleCatalogRoundInfoListModel[] = [];

  /** 媒体の対象ラジオボタン 1: 1物N価、2: 予約 */
  public outputFlag: string = "1";
  /** 媒体区分 */
  public selectedMediumType: string = <string>'';
  /** 束ね企画 */
  public selectBundleCatalogRound: string = <string>'';
  /** 開始受注コード */
  public startOrderCode: string = <string>'';
  /** 終了受注コード */
  public endOrderCode: string = <string>'';
  /** 選択した束ね企画の開始受注コード */
  public startBundleOrderCode: string = <string>'';
  /** 選択した束ね企画の終了受注コード */
  public endBundleOrderCode: string = <string>'';
  /** Pコード */
  public pCode: string = <string>'';
  /** アイテムコード */
  public itemCode: string = <string>'';
  /** 注文番号 */
  public orderNum: string = <string>'';
}
